export class ChartData {
    xAxisTitle: string;
    yAxisTitle: string;
    categories: any[];
    series: ChartSeries[];
}

export class ChartSeries {
    name: string;
    data: any[];
}


// WEBPACK FOOTER //
// ./src/app/user-controls/chart/entities/chart-data.ts